import _ from 'lodash'

export default {
  create: (state, payload) => {
    state.items.push(payload)
  },
  setSpeed: (state, speed) => {
    state.speed = speed
  },
  setActive: (state, id) => {
    state.active = id
  },
  setInitialized: (state, which) => {
    state.initialized = which
  },
  // setAnimating: (state, animating) => {
  //   state.animating = animating
  // },
  // setPause: (state, which) => {
  //   state.pause = which
  // },
  // setPrevious: (state, id) => {
  //   state.previous = id
  // },
  setTheme: (state, theme) => {
    state.theme = theme
  },
  setNavTheme: (state, theme) => {
    state.navtheme = theme
  },
  setLogoTheme: (state, theme) => {
    state.logotheme = theme
  },
  scrollToPanel: (state, id) => {
    state.scrolltopanel = id
  },
  setFirstActive: (state, id) => {
    state.isfirstactive = id
  },
  setLastActive: (state, id) => {
    state.islastactive = id
  },
  setScrollToComplete: (state, which) => {
    state.scrolltocomplete = which
  },
  addActive: (state, id) => {
    const i = _.findIndex(state.activepanels, id)
    if (i === -1) state.activepanels.push(id)
  },
  removeActive: (state, id) => {
    _.pull(state.activepanels, id)
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/panels/mutations.js